import styled from 'styled-components';
import { DEVICES } from '../../config/appConfig';
export const TestimonialContainer = styled.div`
  margin-top: 100px;
  margin-bottom: 100px;
  background: #404040;
  padding-top: 50px;
  padding-bottom: 100px;
  .title {
    color: #fff;
  }
  @media ${DEVICES.mobile} {
    padding-bottom: 50px;
  }
`;
export const TestimonialRow = styled.div`
  max-width: 1170px;
  width: 100%;
  margin: 0 auto;
  .slick-dots {
    bottom: -50px;
  }
  .slick-dots li button::before {
    color: #d1d1d1 !important;
    opacity: 1 !important;
  }
  .slick-dots li.slick-active button::before {
    opacity: 1 !important;
    color: #f58220 !important;
  }
  .slick-dots li button::before {
    font-size: 12px;
  }
  @media ${DEVICES.mobile} {
    .slick-dots {
      bottom: -30px;
    }
  }
  @media ${DEVICES.sMobile} {
    .slick-dots {
      bottom: -20px;
    }
  }
`;
export const TestimonialText = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 15px;
  position: relative;
  margin: 20px;
  &:after {
    content: ' ';
    position: absolute;
    left: 5px;
    bottom: -10px;
    border-top: 15px solid #fff;
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
    border-bottom: none;
  }
`;
export const TestimonialPara = styled.div`
  font-size: 16px;
  min-height: 146px;
  position: relative;
  z-index: 1;
  &:before {
    content: '“';
    position: absolute;
    z-index: -1;
    color: #ffe7d3;
    font-size: 140px;
    top: -60px;
    left: -10px;
    font-family: Century !important;
  }
  @media ${DEVICES.mobile} {
    font-size: 14px;
  }
`;
export const TestimonialUser = styled.div`
  display: flex;
  margin-top: 20px;
  margin-left: 40px;
  img {
    width: auto;
  }
  @media ${DEVICES.sMobile} {
    margin-left: 22px;
    img {
      width: 40px;
      height: 40px;
    }
  }
`;
export const TestimonialDesignation = styled.div`
  b {
    margin-left: 20px;
    display: block;
    color: #f58220;
    font-weight: 700;
  }
  span {
    margin-left: 20px;
    color: #fff;
  }
  @media ${DEVICES.mobile} {
    b {
      margin-left: 10px;
    }
    span {
      font-size: 14px;
      margin-left: 10px;
    }
  }
  @media ${DEVICES.sMobile} {
    b {
      margin-left: 10px;
    }
    span {
      font-size: 14px;
      margin-left: 10px;
    }
  }
`;
